import React from 'react';
import Input from '../Input';
const ColumnControllerInput = ({ currentColumnValue, pairColumnValue, minValue, dataHook, className, onChange, disabled, }) => {
    const formatValue = (newValue) => `${Number(newValue.toFixed(0))}`;
    const [value, setValue] = React.useState(formatValue(currentColumnValue));
    React.useEffect(() => {
        setValue(formatValue(currentColumnValue));
    }, [currentColumnValue]);
    const getUpdatedColumnValues = (value) => {
        // Allow whole number with one or two digits
        const validValueRegex = /^\d{1,2}$/;
        const pairColumnsSum = pairColumnValue + currentColumnValue;
        const newCurrentColumnValue = Number(value);
        const newPairColumnValue = pairColumnsSum - newCurrentColumnValue;
        const isValueValid = value.match(validValueRegex) &&
            newCurrentColumnValue >= minValue &&
            newPairColumnValue >= minValue;
        return {
            newCurrentColumnValue,
            newPairColumnValue,
            isValueValid,
        };
    };
    const handleValueChange = ({ newValue, resetInvalidValue = true, }) => {
        const { newCurrentColumnValue, newPairColumnValue, isValueValid } = getUpdatedColumnValues(newValue);
        if (isValueValid) {
            return onChange({
                currentColumnValue: newCurrentColumnValue,
                pairColumnValue: newPairColumnValue,
            });
        }
        resetInvalidValue && setValue(formatValue(currentColumnValue));
    };
    const handleInputChange = (newValue) => {
        // Allow empty string and whole number with one or two digits
        const validInputRegex = /^(?:\d{1,2})?$/;
        if (newValue.match(validInputRegex)) {
            setValue(newValue);
            handleValueChange({ newValue, resetInvalidValue: false });
        }
    };
    const handleKeyDown = (event) => {
        if (event.key === 'ArrowUp') {
            handleValueChange({ newValue: String(currentColumnValue + 1) });
        }
        if (event.key === 'ArrowDown') {
            handleValueChange({ newValue: String(currentColumnValue - 1) });
        }
    };
    return (React.createElement(Input, { dataHook: dataHook, className: className, disabled: disabled, size: "small", inputProps: {
            onBlur: () => handleValueChange({ newValue: value }),
            onKeyDown: handleKeyDown,
        }, value: value, onChange: handleInputChange, suffix: "%" }));
};
export default ColumnControllerInput;
//# sourceMappingURL=ColumnControllerInput.js.map